import React from 'react';
import PropTypes from 'prop-types';
import PriceMatrixBody from './PriceMatrixBody';
import PriceMatrixHead from './PriceMatrixHead';

const PriceMatrix = (props) => {
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-sm table-price-matrix">
        <PriceMatrixHead {...props} />
        <PriceMatrixBody {...props} />
      </table>
    </div>
  );
};

PriceMatrix.propTypes = {
  usCombined: PropTypes.object.isRequired,
  quoteStep: PropTypes.string.isRequired,
  parameters: PropTypes.object.isRequired,
}

export default PriceMatrix;
